<template>
  <div class="_margin-bottom-30">
    <h4 class="question _margin-bottom-30">Please tell us more about your home</h4>

    <h6 class="_margin-top-20 _margin-bottom-10">
      How is your home currently heated?
    </h6>

    <div class="row">
      <div class="col-xs-6 col-sm-4" v-for="item in heatingTypeList" :key="item.id">
        <radio-button v-model="quote.heatingFuel" :value="item.id" :disabled="item.disabled"
          :error="$v.heatingFuel.$error">
          {{ item.label }}
        </radio-button>
      </div>
    </div>

    <div class="_margin-top-30" v-if="quote.compareFuel == 'gasElectricity'">
      <small>
        We have pre-selected Gas Heating for your home based on the dual fuel (gas and electricity) supply
        registered at your property, as most dual-fuel homes use gas for heating.
      </small>
    </div>

    <div class="_margin-top-30" v-if="quote.compareFuel == 'electricity'">
      <small>
        We have pre-selected Electric Heating for your home based on an electricity only supply registered at your
        property. If this isn't correct, please update your selection.
      </small>
    </div>

    <div class="card-footer">
      <div class="col-xs-6">
        <uiv-btn @click="onBack">Back</uiv-btn>
      </div>

      <div class="col-xs-6 text-right">
        <uiv-btn type="primary" @click="onGoToQuestion('next')" :disabled="!quote.heatingFuel">
          Next
        </uiv-btn>
      </div>
    </div>
  </div>
</template>

<script>
import RadioButton from '../../../../../base/components/forms/RadioButton';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'HeatingInsulation',
  props: {
    $v: Object
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote,
      insulationList: ({ lookups }) => lookups.insulationTypes,
      heatingTypeList: ({ quote, lookups }) => {
        if (quote.compareFuel == 'electricity') {
          return lookups.heatingTypes.filter(({ id }) => id != 1).map(item => {
            item.disabled = false;
            return item;
          });
        }

        if (quote.compareFuel == 'gasElectricity') {
          return lookups.heatingTypes.filter(({ id }) => id != 3).map(item => {
            item.disabled = item.id == 2;
            return item;
          });
        }

        return lookups.heatingTypes;
      }
    }),
    ...mapGetters({
      progress: 'quote_questions/progress'
    })
  },
  methods: {
    ...mapActions({
      goToQuestion: 'quote_questions/goToQuestion'
    }),
    onBack() {
      this.goToQuestion({ type: 'prev' });
      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Property Heat Type' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Back' });
      this.$store.dispatch('tracing/saveActions');
    },
    async onGoToQuestion(type) {
      this.$v.heatingFuel.$touch();

      if (this.$v.heatingFuel.$invalid) return;
      const heatType = this.heatingTypeList.find(({ id }) => id == this.quote.heatingFuel);

      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Property Heat Type' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Choose' });
      this.$store.dispatch('tracing/addAction', { name: 'Value', value: heatType.label });
      await this.$store.dispatch('tracing/saveActions');

      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Property Heat Type' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Next' });
      await this.$store.dispatch('tracing/saveActions');

      const lastStep = await this.goToQuestion({ type });
      if (lastStep) {
        const error = await this.$store.dispatch('quote/newQuote', 'ashp');
        this.error = error;

        if (!error) {
          this.$router.push({ name: 'quoteResults' });
        }
      }
    }
  },
  components: {
    RadioButton
  }
};
</script>

<style lang="scss" scoped></style>
